import axios from "axios";
import { BASE_URL } from "./api";

// Clients with their account manager, that manager's assignment history, and
// account staff. Read-only.
export async function getClientAssignments(token) {
  return axios({
    method: "get",
    url: `${BASE_URL}/client-assignments/`,
    headers: { Authorization: `Token ${token}` },
  })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
}
